import { CropResidue, LandChanges } from 'models/Farmbox/field.model';

export const filterOutEmptyObjects = (arr: LandChanges[]) =>
  arr?.filter(obj => Object.values(obj).every(value => value !== undefined && value!== null ));

export const filterOutCropsEmptyObjects = (arr: CropResidue[]) =>
  arr?.filter(obj => Object.values(obj).some(value => value !== undefined));
